<template>
  <div class="treePage">
    <!-- 搜索界面 -->
    <form action="/" class="search" id="searchHeight">
      <van-search
        v-model="searchKeyword"
        placeholder="请输入小地名/古树名称/上传人"
        show-action
        @search="onSearch"
        @cancel="onCancel"
      />
    </form>
    <!-- 古树列表 -->
    <div class="pageMain" id="pageMain">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        :offset="100"
        finished-text="没有更多了"
      >
        <div class="searchBox">
          <van-cell v-for="item in commentlists" :key="item.id" class="item">
            <ul class="treeDetail" @click="treeProp(item)">
              <li>
                古树编号：
                <span>{{ item.code }}</span>
              </li>
              <li>
                位置：
                <span>{{ item.regionCodeName }}</span>
              </li>
              <li>
                小地名：
                <span>{{ item.placeName }}</span>
              </li>
              <li>
                古树名称：
                <span>{{ item.entryName }}</span>
              </li>
              <li>
                保护级别：
                <span>{{ item.treeClassesName }}</span>
              </li>
              <li>
                树龄（年）：
                <span>{{ item.treeAge }}</span>
              </li>
              <li>
                关注次数：
                <span>{{ item.viewCount }}</span>
              </li>
              <li>
                评论：
                <span>{{ item.commentCount }}</span>
              </li>
              <li>
                上传人：
                <span>{{ item.creatorName }}</span>
              </li>
              <li>
                上传时间：
                <span>{{ item.createTime }}</span>
              </li>
              <li v-if="item.isDraft" class="caogao">草稿</li>
            </ul>
          </van-cell>
        </div>
      </van-list>
    </div>
    <!-- 弹出层：搜索内容 -->
    <van-popup
      v-model="treeListDataPicker"
      round
      position="bottom"
      class="treeListDataPicker"
      :style="{ height: '50%' }"
    >
      <van-cell-group class="switchbox">
        <van-field
          label="古树状态："
          :value="treeListData.enable ? '启用' : '停用'"
          class="switchlist"
        />
        <van-switch
          :value="treeListData.enable"
          @input="checkSwitchType(treeListData)"
          size="24px"
          active-color="#07c160"
          inactive-color="#e1e1e1"
          title="古树状态："
          class="switchController"
        />
      </van-cell-group>
      <div class="btnBox">
        <a href="javascript:void(0);" @click="getRecord(treeListData.id)"
          >古树档案</a
        >
        <a href="javascript:void(0);" @click="getRepair(treeListData.id)"
          >修复记录</a
        >
        <a href="javascript:void(0);" @click="getQuickMark(treeListData)"
          >二维码下载</a
        >
        <a href="javascript:void(0);" @click="handleDelete(treeListData.id)"
          >删除</a
        >
      </div>
    </van-popup>
  </div>
</template>
<script>
/*eslint-disable*/
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "gushuManageList",
  created() {
    document.title = "古树管理"; //设置title的值。
  },
  components: {
    // linkage
  },
  data() {
    return {
      clientType: "",
      sysToken: "",
      sysClient: "",
      areaList: "", //区域数组
      areaValue: "100000", //选择所在地的地址
      showSearchMain: false, //搜索内容 默认隐藏
      searchKeyword: "", //搜索值
      commentlists: [],
      backstagelists: [],
      applists: [],
      commentCount: 0,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      page: 0,
      pageSize: 10,
      contentHeight: 0,
      keyWord: "", //搜索关键字
      treeListData: "", // 弹框
      treeListDataPicker: false,
    };
  },

  mounted() {
    this.clientType = getDeviceType();
    let winHeight = document.documentElement.clientHeight; //视口大小
    let sHeight = document.getElementById("searchHeight").clientHeight;
    document.getElementById("pageMain").style.height =
      winHeight - sHeight + "px"; //调整上拉加载框高度
    window.getfindRecord = this.getRecord;
    window.addElement = this.getRecord;
    this.sysToken = this.$route.query.sysToken || "";
    this.sysClient = this.$route.query.sysClient || "";
    if (this.clientType == "android") {
      window.android.getInfo(202, "增加"); //  添加新增按钮
    } else {
      //IOS
      window.webkit.messageHandlers.addMain.postMessage("1");
    }
  },
  methods: {
    //搜索功能
    onSearch() {
      this.keyWord = this.searchKeyword;
      this.reloadPage();
    },
    onCancel() {
      this.keyWord = "";
      //  this.reloadPage();
      window.location.reload();
    },
    //古树列表渲染
    getTest() {
      let _this = this;
      if (_this.page != 0 && this.page * 10 >= parseInt(_this.commentCount)) {
        return;
      }
      _this.page += 1;
      _this.$api.slbkOldTree
        .treeList(_this.page, _this.pageSize, {
          keyWord: _this.keyWord,
        })
        .then((res) => {
          if (res.code == "1") {
            _this.backstagelists = res.data.list;
            _this.commentCount = res.data.total;
            _this.viewLists();
            // 加载状态结束
            this.loading = false;

            if (_this.page * 10 >= res.data.total) {
              _this.finished = true;
              console.log("加载完成");
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
    viewLists() {
      this.commentlists = this.commentlists.concat(this.backstagelists);
    },
    treeProp(item) {
      //点击出现弹框
      this.treeListData = item;
      this.treeListDataPicker = true;
    },
    checkSwitchType(item) {
      //  切换状态
      let _this = this;
      // Dialog({ message: '提示' });

      _this.$dialog
        .confirm({
          title: "提醒",
          message: "是否确认该操作？",
        })
        .then(() => {
          // on confirm
          this.$set(item, "enable", !item.enable);

          _this.$api.slbkOldTree.state(item.enable, item.id).then((res) => {
            if (res.code == 1) {
              if (item.enable) {
                _this.treeListDataPicker = false;
                _this.$toast("古树名木启用成功");
              } else {
                _this.treeListDataPicker = false;
                _this.$toast("古树名木停用成功");
              }
            } else {
              _this.$toast(res.msg);
            }
          });
        });
    },
    //跳转古树档案
    getRecord(treeId) {
      this.treeListDataPicker = false;
      let jumpUrl = window.location.protocol + "//" + window.location.host + "";
      let timestamp = Date.parse(new Date());
      // window.location.href =
      //   "" +
      //   jumpUrl +
      //   "/dhome-pageH5/#/treeRecord?treeId=" +
      //   treeId +
      //   "&time=" +
      //   timestamp +
      //   "";
      if (this.clientType == "android") {
        window.android.getInfo(
          118,
          "" +
            jumpUrl +
            "/dhome-lzz-lzt-h5/#/gushuRecord?treeId=" +
            treeId +
            "&sysToken=" +
            this.sysToken +
            "&sysClient=" +
            this.sysClient +
            "&time=" +
            timestamp +
            ""
        );
      } else {
        //IOS
        let token = this.$route.query.token;
        window.webkit.messageHandlers.getJumpUrl.postMessage(
          "" +
            jumpUrl +
            "/dhome-lzz-lzt-h5/#/gushuRecord?treeId=" +
            treeId +
            "&sysToken=" +
            this.sysToken +
            "&sysClient=" +
            this.sysClient +
            "&time=" +
            timestamp +
            "&token=" +
            token +
            ""
        );
      }
    },
    //古树修复记录
    getRepair(treeId) {
      this.treeListDataPicker = false;
      let jumpUrl = window.location.protocol + "//" + window.location.host + "";
      let timestamp = Date.parse(new Date());
      // sysToken = this.$route.query.sysToken;
      // sysClient = this.$route.query.sysClient;
      // window.location.href =
      //   "" +
      //   jumpUrl +
      //   "/dhome-pageH5/#/treeRepair?treeId=" +
      //   treeId +
      //   "&time=" +
      //   timestamp +
      //   "";

      if (this.clientType == "android") {
        window.android.getInfo(
          118,
          "" +
            jumpUrl +
            "/dhome-lzz-lzt-h5/#/gushuRepair?treeId=" +
            treeId +
            "&sysToken=" +
            this.sysToken +
            "&sysClient=" +
            this.sysClient +
            "&time=" +
            timestamp +
            ""
        );
      } else {
        //IOS
        let token = this.$route.query.token;
        window.webkit.messageHandlers.getJumpUrl.postMessage(
          "" +
            jumpUrl +
            "/dhome-lzz-lzt-h5/#/gushuRepair?treeId=" +
            treeId +
            "&time=" +
            timestamp +
            "&sysToken=" +
            this.sysToken +
            "&sysClient=" +
            this.sysClient +
            ""
        );
      }
    },
    //下载二维码
    getQuickMark(item) {
      if (this.clientType == "android") {
        window.android.getInfo(204, item.shortUrl);
      } else {
        window.webkit.messageHandlers.dimensionCode.postMessage(item.shortUrl);
      }

      this.treeListDataPicker = false;
    },
    //删除古树
    handleDelete(id) {
      let _this = this;
      // Dialog({ message: '提示' });
      _this.$dialog
        .confirm({
          title: "提醒",
          message: "您确认要删除当前古树所有资料?",
        })
        .then(() => {
          // on confirm
          _this.$api.slbkOldTree.delete(id).then((res) => {
            if (res.code == "1") {
              if (res.code == "1") {
                _this.$toast("古树档案删除成功!");
                this.treeListDataPicker = false;
                _this.reloadPage(); //删除成功后刷新列表数据
              } else {
                _this.$toast(res.msg);
              }
            } else {
              this.treeListDataPicker = false;
              _this.$toast(res.msg);
            }
          });
        });
    },
    reloadPage: function () {
      this.page = 0;
      this.commentlists = [];
      setTimeout(() => {
        this.getTest();
      }, 300);
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.getTest();
      }, 500);
    },
  },
};
</script>
<style lang="less">
@import "./css/treeManage.less";
</style>